import "../styles/projects.css";

function ProjectCard(props) {
    return (
        <div className="box">
            <div className="textandlink">
                <a href={props.link} target="_blank" rel="noreferrer"> {props.description} </a>
            </div>
            <div>
                <img id="img1" src={props.image1} alt={props.alt} />
                <img id="img2" src={props.image2} alt={props.alt} />
            </div>
        </div>
    )
}

export default ProjectCard;